/**
 * PageLayout — Standard page wrapper for all views.
 * Provides consistent title, subtitle, action button, and content padding.
 */
import React from 'react';

interface PageAction {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
}

interface PageLayoutProps {
  title: string;
  subtitle?: string;
  action?: PageAction;
  actions?: PageAction[];
  children: React.ReactNode;
}

export default function PageLayout({ title, subtitle, action, actions, children }: PageLayoutProps) {
  const allActions = actions || (action ? [action] : []);

  return (
    <div style={{ padding: '24px 32px', maxWidth: 1600, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--navy-900)', margin: 0, letterSpacing: '-0.3px' }}>
            {title}
          </h1>
          {subtitle && (
            <p style={{ fontSize: 13, color: 'var(--text-hint)', margin: '4px 0 0', lineHeight: 1.4 }}>
              {subtitle}
            </p>
          )}
        </div>
        {allActions.length > 0 && (
          <div style={{ display: 'flex', gap: 8 }}>
            {allActions.map((a, i) => (
              <button
                key={i}
                onClick={a.onClick}
                style={{
                  padding: '8px 18px', borderRadius: 6, fontSize: 13, fontWeight: 600,
                  cursor: 'pointer', border: 'none', transition: 'all 0.15s',
                  background: (a.variant || 'primary') === 'primary' ? '#1e3a5f' : '#ffffff',
                  color: (a.variant || 'primary') === 'primary' ? '#fff' : 'var(--text-secondary)',
                  ...(a.variant === 'secondary' ? { border: '1px solid var(--border-default)' } : {}),
                }}
              >
                {a.label}
              </button>
            ))}
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
